import { IFetchUserInfoResponse } from '@/store/modules/auth/interfaces/getUserInfo/IFetchUserInfoResponse'
import { ROLE_DEFINITIONS } from '@/store/modules/auth/services/roleDefinitions'

export function buildUserInfoFromSession (gigya: any): IFetchUserInfoResponse {
  const data = gigya?.data ?? {}
  const profile = gigya?.profile ?? {}
  const orgs: any[] = gigya?.groups?.organizations ?? []

  return {
    id: gigya.UID ?? '',
    firstName: profile.firstName ?? '',
    lastName: profile.lastName ?? '',
    email: profile.email ?? gigya?.emails?.verified?.[0] ?? '',
    phone: profile.phoneNumber ?? '',
    isActive: gigya.isActive ?? true,
    termsAgreed: true,
    createdAt: gigya.created ?? '',
    showTutorial: Number(data.showTutorial ?? 0),
    firstLogin: data.firstLogin ? data.firstLogin !== 'False' : null,
    userValidation: data.userValidation ? data.userValidation === 'true' : null,
    isKeyAccount: false,
    consentToBeApproved: false,
    marketingConsentAgreed: false,
    isEssentialCommunicationPrefActive: false,
    isOrderAndBillingPrefActive: false,
    isPersonalizedOffersPrefActive: false,
    isProductAndServicePrefActive: false,
    defaultShipToID: data.defaultShipToID ? String(data.defaultShipToID) : null,
    permissionSchema: orgs.map((org: any) => ({
      roles: org.roles ?? [],
      soldToId: '',
      shipToId: String(org.bpid ?? ''),
      shipToName: org.orgName ?? '',
      shipToStatus: org.status === 'active' ? 'APPROVED' : (org.status ?? 'APPROVED'),
      companyId: String(org.department ?? ''),
      companyName: org.orgName ?? '',
      rpDetails: (org.roles ?? []).map((roleId: string) => ROLE_DEFINITIONS[roleId]).filter(Boolean)
    }))
  }
}
